import { createFileRoute } from "@tanstack/react-router";
import { ProcessSteps } from "#/components/pages/process";
import { FinalCTA } from "#/components/pages/home";
import { PageHeader } from "#/components/shared/PageHeader";
import { HEADER } from "#/lib/images";
import { getProcessPageSchema } from "#/lib/seo";

const TITLE = "Our Process | Blue Rock Concrete";
const DESCRIPTION =
  "How we build concrete that lasts: our 7 step process from free on-site estimate through site prep, pour, finish, and a sealed, warrantied result.";

export const Route = createFileRoute("/process")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://bluerockconcreteco.com/process" },
    ],
    links: [{ rel: "canonical", href: "https://bluerockconcreteco.com/process" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(getProcessPageSchema()),
      },
    ],
  }),
  component: ProcessPage,
});

function ProcessPage() {
  return (
    <main>
      <PageHeader
        eyebrow="Our Process"
        title="How we build it right"
        intro="Seven steps, no shortcuts. Here is exactly what happens between your first call and a finished slab that lasts."
        image={HEADER.process.src}
        imageMobile={HEADER.process.mobile}
        imageAlt={HEADER.process.alt}
      />

      <ProcessSteps />

      <FinalCTA />
    </main>
  );
}
